import { Trans, useTranslation } from 'react-i18next';

import { TranslatedTitle } from '../../../components';
import { Contract } from '../Contract';

import { SignContractWrapper } from './SignContract.styles';

import { ColoredText } from '@/pages/Student/Onboarding/styles';

export const SignContract = () => {
  const { t } = useTranslation('StudentOnboardingPageTranslations');

  return (
    <SignContractWrapper>
      <div>
        <TranslatedTitle i18nKey="SIGN_CONTRACT" />
        <span>{t('SIGN_CONTRACT_SUBTITLE')}</span>
      </div>
      <Contract />
      <span>
        <Trans
          i18nKey={`StudentOnboardingPageTranslations:SIGN_CONTRACT_FOOTER`}
          components={{
            span: <ColoredText />
          }}
        />
      </span>
    </SignContractWrapper>
  );
};
